import { useMemo } from "react";
import { imagePlaceholder } from "../../helpers/placeholders";
import { useEditor } from "../EditorProvider";
import { useSite } from "../SiteProvider";
const useBackgroundProps = (backgroundImage) => {
    const { mode } = useEditor();
    const { repeatableItem } = useSite();
    const generateSrc = useMemo(() => {
        if (backgroundImage?.type === "repeatableField") {
            if (mode === "production") {
                const imageField = repeatableItem?.values.find((v) => v.field.identifier === backgroundImage?.identifier)?.value;
                return imageField ? JSON.parse(imageField).src : imagePlaceholder.src;
            }
            return null;
        }
        return backgroundImage?.src;
    }, [backgroundImage, mode, repeatableItem]);
    return {
        props: {
            "editor-background-image-src": backgroundImage?.src,
            "editor-background-image-file": backgroundImage?.file,
            "editor-img-type": backgroundImage?.type || "image",
            "editor-img-field-identifier": backgroundImage?.identifier,
        },
        style: {
            ...(generateSrc && { backgroundImage: `url(${generateSrc})` }),
        },
    };
};
export default useBackgroundProps;
//# sourceMappingURL=useBackgroundProps.js.map